export default (url) => {
  if (url == '') {
    url = 'https://h5-activity.yayya.live/img/app/blank.png'
  }
  if (url) {
    url = url.replace('http://', 'https://')
    if (url.indexOf('http') !== 0) {
      url = `https://h5-activity.yayya.live` + url
    }
    if (url.indexOf('aliyuncs.com') > 0 && url.indexOf('x-oss-process') == -1) {
      url = url + `?x-oss-process=image/resize,w_150,h_150,m_fill`
    }
    if (url.indexOf('upload-sg.chatie.live') > 0 && url.indexOf('x-oss-process') == -1) {
      url = url + `?x-oss-process=image/resize,w_150,h_150,m_fill`
    }
  }
  return url
}



// WEBPACK FOOTER //
// src/helper/cdn.js